import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const TimeCardReport = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M22 14V9C22 6.243 19.757 4 17 4H9C6.243 4 4 6.243 4 9V21C4 23.757 6.243 26 9 26H15.076C16.461 28.389 19.045 30 22 30C26.411 30 30 26.411 30 22C30 17.589 26.411 14 22 14ZM16 6V7C16 7.551 15.551 8 15 8H11C10.449 8 10 7.551 10 7V6H16ZM14.253 24H9C7.346 24 6 22.654 6 21V9C6 7.696 6.836 6.585 8 6.172V7C8 8.654 9.346 10 11 10H15C16.654 10 18 8.654 18 7V6.172C19.164 6.585 20 7.696 20 9V14.253C16.553 15.143 14 18.279 14 22C14 22.69 14.088 23.361 14.253 24ZM22 28C18.692 28 16 25.308 16 22C16 18.692 18.692 16 22 16C25.308 16 28 18.692 28 22C28 25.308 25.308 28 22 28Z" />
		<path d="M11 22H9C8.448 22 8 21.552 8 21C8 20.448 8.448 20 9 20H11C11.552 20 12 20.448 12 21C12 21.552 11.552 22 11 22Z" />
		<path d="M22.625 24H19.875C19.323 24 18.875 23.552 18.875 23C18.875 22.448 19.323 22 19.875 22H21.625V20C21.625 19.448 22.073 19 22.625 19C23.177 19 23.625 19.448 23.625 20V23C23.625 23.552 23.177 24 22.625 24Z" />
		<path d="M11 18H9C8.448 18 8 17.552 8 17C8 16.448 8.448 16 9 16H11C11.552 16 12 16.448 12 17C12 17.552 11.552 18 11 18Z" />
		<path d="M15 14H9C8.448 14 8 13.552 8 13C8 12.448 8.448 12 9 12H15C15.552 12 16 12.448 16 13C16 13.552 15.552 14 15 14Z" />
	</svg>
);

export default TimeCardReport;
